import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "style", "onChange", "color", "colors", "rectProps", "rectRender"];
import React, { useCallback } from 'react';
import { color as handleColor, hexToHsva, validHex, hsvaToHex, getContrastingColor } from '@uiw/color-convert';
import EditableInput from '@uiw/react-color-editable-input';
import RGBA from '@uiw/react-color-editable-input-rgba';
import Swatch from '@uiw/react-color-swatch';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var COLORS = ['#4D4D4D', '#999999', '#FFFFFF', '#F44E3B', '#FE9200', '#FCDC00', '#DBDF00', '#A4DD00', '#68CCCA', '#73D8FF', '#AEA1FF', '#FDA1FF', '#333333', '#808080', '#cccccc', '#D33115', '#E27300', '#FCC400', '#B0BC00', '#68BC00', '#16A5A5', '#009CE0', '#7B64FF', '#FA28FF', '#000000', '#666666', '#B3B3B3', '#9F0500', '#C45100', '#FB9E00', '#808900', '#194D33', '#0C797D', '#0062B1', '#653294', '#AB149E'];
function Point(props) {
  if (!props.checked) return null;
  return /*#__PURE__*/_jsx("div", {
    style: {
      height: 5,
      width: 5,
      borderRadius: '50%',
      backgroundColor: getContrastingColor(props.color)
    }
  });
}
var Compact = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-color-compact',
      className,
      style,
      onChange,
      color,
      colors = COLORS,
      rectProps,
      rectRender
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var hsva = typeof color === 'string' && validHex(color) ? hexToHsva(color) : color;
  var hex = color ? hsvaToHex(hsva).replace(/^#/, '') : '';
  var handleChangeCallback = useCallback(hsv => onChange && onChange(handleColor(hsv)), []);
  var handleHex = (value, evn) => {
    if (typeof value === 'string' && validHex(value) && /(3|6)/.test(String(value.length))) {
      handleChangeCallback(hexToHsva(value));
    }
  };
  var rgbProps = {
    style: {
      alignItems: 'baseline'
    },
    inputStyle: {
      boxShadow: 'none',
      backgroundColor: 'transparent',
      outline: 0
    }
  };
  var wrapperStyle = _extends({
    '--compact-background-color': '#f6f6f6',
    background: 'var(--compact-background-color)',
    borderRadius: 3,
    display: 'flex',
    width: 240,
    flexWrap: 'wrap',
    paddingTop: 5,
    paddingLeft: 5
  }, style);
  return /*#__PURE__*/_jsxs("div", _extends({
    ref: ref,
    style: wrapperStyle,
    className: [prefixCls, className || ''].filter(Boolean).join(' ')
  }, other, {
    children: [/*#__PURE__*/_jsx(Swatch, {
      colors: colors,
      color: color ? hsvaToHex(hsva) : undefined,
      rectRender: rectRender,
      rectProps: _extends({
        children: /*#__PURE__*/_jsx(Point, {})
      }, rectProps, {
        style: _extends({
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }, rectProps == null ? void 0 : rectProps.style)
      }),
      onChange: hsvColor => handleChangeCallback(hsvColor)
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: 'flex',
        margin: '0 4px 3px 0'
      },
      children: [/*#__PURE__*/_jsx(EditableInput, {
        onChange: (evn, val) => handleHex(val, evn),
        labelStyle: {
          paddingRight: 5,
          marginTop: -1
        },
        value: hex.toLocaleUpperCase(),
        label: /*#__PURE__*/_jsx("div", {
          style: {
            width: 8,
            height: 8,
            backgroundColor: "#" + hex
          }
        }),
        inputStyle: {
          outline: 'none',
          boxShadow: 'initial',
          background: 'transparent'
        },
        style: {
          flexDirection: 'row-reverse',
          flex: '1 1 0%',
          minWidth: 80
        }
      }), /*#__PURE__*/_jsx(RGBA, {
        hsva: hsva,
        placement: "left",
        onChange: result => handleChangeCallback(result.hsva),
        aProps: false,
        rProps: rgbProps,
        gProps: rgbProps,
        bProps: rgbProps
      })]
    })]
  }));
});
Compact.displayName = 'Compact';
export default Compact;